var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M12 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M3 24c1.7 0 3-1.3 3-3 0-1.3-.8-2.4-2-2.8V17h7v1.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8V17h7v1.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8V15h-9v-1.1c3.4-.5 6-3.4 6-6.9 0-3.9-3.1-7-7-7S5 3.1 5 7c0 3.5 2.6 6.4 6 6.9V15H2v3.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3m9-2c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1m9 0c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1M7 7c0-2.8 2.2-5 5-5s5 2.2 5 5c0 1.6-.8 3.1-2 4v-1c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v1c-1.2-.9-2-2.4-2-4M3 20c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1"
  })));
};
export default SvgUsers;